<div class="container py-4">
  <h1 class="mb-4">Privacy Policy</h1>
  <p class="text-muted">Last updated: 18 February 2026</p>

  <p>
    Plate Tech Ltd ("PlateX", "we", "us", or "our") operates the website
    <a href="https://www.platex.co.uk">www.platex.co.uk</a> (the "Site"). This Privacy Policy explains how
    we collect, use, disclose, and safeguard your information when you visit the Site or use our services.
    Please read this policy carefully. If you do not agree with its terms, please discontinue use of the Site.
  </p>

  <h2 class="mt-4">1. Information We Collect</h2>
  <p>We may collect the following categories of personal information:</p>
  <ul>
    <li><strong>Account information</strong> – name, email address, and password when you register an account.</li>
    <li><strong>Social login data</strong> – if you sign in via Google or Facebook, we receive your name, email address, and profile picture as permitted by those platforms.</li>
    <li><strong>Transaction data</strong> – details of purchases or sales you carry out through the Site.</li>
    <li><strong>Technical data</strong> – IP address, browser type and version, time zone, browser plug-in types and versions, operating system, and other technology on the devices you use to access the Site.</li>
    <li><strong>Usage data</strong> – information about how you use the Site, products, and services.</li>
    <li><strong>Communications</strong> – messages you send to us or to other users through the Site.</li>
  </ul>

  <h2 class="mt-4">2. How We Use Your Information</h2>
  <p>We use the information we collect to:</p>
  <ul>
    <li>Create and manage your account.</li>
    <li>Process transactions and send related information, including purchase confirmations.</li>
    <li>Send administrative information, such as changes to our terms, conditions, and policies.</li>
    <li>Respond to your comments, questions, and provide customer service.</li>
    <li>Monitor and analyse usage and trends to improve your experience.</li>
    <li>Comply with legal obligations.</li>
    <li>Prevent fraudulent transactions, monitor against theft, and protect against criminal activity.</li>
  </ul>

  <h2 class="mt-4">3. Legal Basis for Processing (UK/EEA Users)</h2>
  <p>We process your personal data on the following legal bases:</p>
  <ul>
    <li><strong>Contract</strong> – processing necessary to perform a contract with you (e.g., facilitating a sale).</li>
    <li><strong>Legitimate interests</strong> – improving the Site, fraud prevention, and direct marketing where lawful.</li>
    <li><strong>Consent</strong> – where you have given clear consent, such as when signing in via a social provider.</li>
    <li><strong>Legal obligation</strong> – where we must comply with a legal or regulatory obligation.</li>
  </ul>

  <h2 class="mt-4">4. Sharing Your Information</h2>
  <p>We do not sell your personal data. We may share it with:</p>
  <ul>
    <li><strong>Service providers</strong> – third parties that perform services on our behalf (hosting, payment processing, analytics).</li>
    <li><strong>Business partners</strong> – only where necessary to complete a transaction you have initiated.</li>
    <li><strong>Legal authorities</strong> – where required by law, court order, or governmental authority.</li>
    <li><strong>Successors</strong> – in connection with a merger, acquisition, or sale of assets, where the acquiring party agrees to honour this policy.</li>
  </ul>

  <h2 class="mt-4">5. Cookies</h2>
  <p>
    We use cookies and similar tracking technologies to access or store information. Specific information about
    how we use such technologies and how you can refuse certain cookies is set out in our Cookie Policy.
    By continuing to use the Site, you consent to our use of cookies in accordance with that policy.
  </p>

  <h2 class="mt-4">6. Data Retention</h2>
  <p>
    We retain personal data only for as long as necessary to fulfil the purposes for which it was collected,
    including for the purposes of satisfying any legal, accounting, or reporting requirements. When data is no
    longer required, we securely delete or anonymise it.
  </p>

  <h2 class="mt-4">7. Your Rights</h2>
  <p>Depending on your location, you may have the following rights regarding your personal data:</p>
  <ul>
    <li><strong>Access</strong> – request a copy of the personal data we hold about you.</li>
    <li><strong>Rectification</strong> – ask us to correct inaccurate or incomplete data.</li>
    <li><strong>Erasure</strong> – request deletion of your personal data (see our Data Deletion page).</li>
    <li><strong>Restriction</strong> – ask us to restrict processing of your data.</li>
    <li><strong>Portability</strong> – receive your data in a structured, machine-readable format.</li>
    <li><strong>Objection</strong> – object to processing based on legitimate interests or for direct marketing.</li>
    <li><strong>Withdraw consent</strong> – where processing is based on consent, withdraw it at any time.</li>
  </ul>
  <p>
    To exercise any of these rights, please contact us at
    <a href="mailto:hugh@platex.co.uk">hugh@platex.co.uk</a>.
    We will respond within 30 days.
  </p>

  <h2 class="mt-4">8. Contact Us</h2>
  <p>
    Plate Tech Ltd<br />
    71-75 Shelton Street, Covent Garden, London, WC2H 9JQ<br />
    Company Number: 16268508<br />
    Email: <a href="mailto:hugh@platex.co.uk">hugh@platex.co.uk</a>
  </p>
</div>
